export const statusOptions = [
  { value: 'todos', title: 'Todos' },
  { value: 'true', title: 'Activos' },
  { value: 'false', title: 'Inactivos' }
];
